export var OPEN_NEW_FEAUTURE_POPPER = 'OPEN_NEW_FEAUTURE_POPPER';
export var CLOSE_NEW_FEAUTURE_POPPER = 'CLOSE_NEW_FEAUTURE_POPPER';
export var openNewFeaturePopperDialog = function (payload) { return ({
    type: OPEN_NEW_FEAUTURE_POPPER,
    payload: payload
}); };
export var closeNewFeaturePopperDialog = function () { return ({
    type: CLOSE_NEW_FEAUTURE_POPPER,
    newFeatureId: '',
    anchorEl: null
}); };
